import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	nearLimitMessage: {
		id: 'servicedesk.automation.summary.header.rule-limit-message.near-limit-message',

		defaultMessage: `{remaining, plural,
            =1 {You can create {remaining, number} more rule in this project.}
            other {You can create {remaining, number} more rules in this project.}
            }`,

		description: '',
	},
	atLimitMessage: {
		id: 'servicedesk.automation.summary.header.rule-limit-message.at-limit-message',
		defaultMessage: "You've reached the limit of {limit, number} rules in this project.",
		description: '',
	},
	overLimitMessage: {
		id: 'servicedesk.automation.summary.header.rule-limit-message.over-limit-message',

		defaultMessage:
			"You've exceeded the limit of {limit, number} rules in this project. You currently have {count, number}.",

		description: '',
	},
	limitDescription: {
		id: 'servicedesk.automation.summary.header.rule-limit-message.limit-description',
		defaultMessage: "There's a limit of {formattedLimit} rules in this project.",
		description: '',
	},
	countRules: {
		id: 'servicedesk.automation.summary.header.rule-limit-message.count-rules',
		defaultMessage: '{count, number} rules',
		description: '',
	},
	contactAtlassianSupport: {
		id: 'servicedesk.automation.summary.header.rule-limit-message.contact-atlassian-support',
		defaultMessage: 'contact Atlassian Support',
		description: '',
	},
	deleteOrContactSupport: {
		id: 'servicedesk.automation.summary.header.rule-limit-message.delete-or-contact-support',
		defaultMessage: 'You can delete some, or {contactSupport} for more.',
		description: '',
	},
});
